import PageError from "common/ui/misc/PageError";
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        //todo: log error
    }

    render() {
        if (this.state.hasError) {
            return <PageError />;
        }

        return this.props.children;
    }
}
export default ErrorBoundary;